"use strict";

define('controller/submission/letter.list',['require','exports','module','underscore','../base','uikit/uikit','../../view/page.list','../../view/table.ellipsis','../../config','../../model/document','../../model/document.letter','../../model/document.decision','../../libs/bind.helper','../../libs/route.helper','langs','../../view/empty.table','evisions/redactor.plugins/macro.redactor.plugin','evisions/redactor.plugins/disabled.redactor.plugin'],function (require, exports, module) {
  var _ = require('underscore'),
    RegionController = require('../base'),
    UIKit = require('uikit/uikit'),
    PageList = require('../../view/page.list'),
    TableEllipsis = require('../../view/table.ellipsis'),
    config = require('../../config'),
    Document = require('../../model/document'),
    DocumentLetterModel = require('../../model/document.letter'),
    DocumentDecisionModel = require('../../model/document.decision'),
    BindHelper = require('../../libs/bind.helper'),
    RouteHelper = require('../../libs/route.helper'),
    langs = require('langs'),
    EmptyTableView = require('../../view/empty.table');
  require('evisions/redactor.plugins/macro.redactor.plugin');
  require('evisions/redactor.plugins/disabled.redactor.plugin');
  var ButtonView = UIKit.Button;
  var p = langs.phrase;
  function generateLetterDetailLink(model) {
    return RouteHelper.createLink(model.isNew() ? 'submission:letterCreate' : 'submission:letterDetail', model, model.isNew() ? {
      documentId: 'documentId'
    } : {
      documentId: 'documentId',
      letterId: 'id'
    });
  }
  ;
  function navigateLetterDetail(model) {
    app.navigate(generateLetterDetailLink(model).slice(1), {
      trigger: true
    });
  }
  ;
  var SubmissionLetterListController = RegionController.extend({
    header: 'Letters',
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new PageList({
          search: false,
          breadcrumbs: true
        }),
        documentId = Number(state.get('documentId')),
        doc = new Document({
          id: documentId
        }),
        letters = DocumentLetterModel.allByDecisionId(),
        lettersByDoc = DocumentLetterModel.allByDocumentId(documentId),
        decisions = DocumentDecisionModel.openByDocumentId(documentId),
        breadcrumb = root.breadcrumb,
        createLinkModel = new RouteHelper('submission:letterCreate').add(doc, {
          documentId: 'id'
        }),
        table = root.table;
      root.$el.css(config.contentCss);
      function setupRowActions(column) {
        return {
          collection: new Backbone.Collection([{
            text: 'Edit',
            icon: 'edit',
            link: generateLetterDetailLink(this.model)
          }, {
            text: 'Delete',
            icon: 'trash',
            action: 'destroy'
          }]),
          childBindings: {
            text: 'text',
            icon: 'icon',
            link: 'link'
          }
        };
      }
      ;
      function onRowAction(row, child, actionModel) {
        var model = row.model;
        switch (actionModel.get('action')) {
          case 'destroy':
            app.request('modal', {
              type: 'CONFIRM_DESTROY',
              state: state,
              name: model.get('name'),
              entity: 'Submission Letter'
            }, {
              ariaControlsId: row.cid
            }).on('destroy:model', function () {
              model.destroy({
                wait: true,
                animate: 'scale'
              });
            });
            break;
        }
      }
      ;
      function unbindAll() {
        this.stopListening().off();
      }
      function createNewLetterButton() {
        return new ButtonView({
          text: p('LetterList.NewButton'),
          icon: 'plus',
          color: 'primary',
          link: createLinkModel.get('link')
        });
      }
      ;
      function prettifyList(value) {
        return value.split(';').join(', ');
      }
      ;
      root.setupCollection(letters, {
        autoFetch: true
      }).addRightHeaderItem(createNewLetterButton()).setupColumns([{
        childView: TableEllipsis,
        collapsing: true,
        childViewOptions: setupRowActions
      }, {
        text: 'Subject',
        data: 'subject'
      }, {
        text: 'Recipients',
        data: 'recipients',
        formatter: prettifyList
      }]).setupEmptyView(EmptyTableView.Row, {
        text: "You have no letters",
        headerTag: 'h4'
      });
      breadcrumb.collection = new Backbone.Collection([{
        text: 'Studies',
        link: RouteHelper.createLink('study:list')
      }, {
        text: 'Study Detail'
      }, {
        text: 'Submission Details'
      }, {
        text: app.title
      }]);
      new BindHelper(new RouteHelper('study:detail').add(doc, {
        studyId: 'studyId'
      }), breadcrumb.collection.at(1)).bind('link', 'link').listenTo(root, 'destroy', unbindAll).transfer();
      new BindHelper(new RouteHelper('submission:detail').add(doc, {
        documentId: 'id',
        studyId: 'studyId'
      }), breadcrumb.collection.at(2)).bind('link', 'link').listenTo(root, 'destroy', unbindAll).transfer();
      table.sortable = false;
      root.listenTo(decisions, 'sync', function () {
        if (decisions.length > 0) {
          letters.params({
            decisionId: decisions.at(0).get('id')
          }).fetch();
        } else {
          root.setupCollection(lettersByDoc, {
            autoFetch: true
          });
          lettersByDoc.fetch();
          lettersByDoc.on('sync', function () {
            letters.trigger('sync');
          });
        }
      }).listenTo(letters, 'add', function (model) {
        model.set('document', doc.clone());
      }).listenTo(lettersByDoc, 'add', function (model) {
        model.set('document', doc.clone());
      }).listenTo(table, 'row:double:press', function (row) {
        navigateLetterDetail(row.model);
      }).listenTo(table, 'row:before:add:child', function (row, child, model, column) {
        if (child instanceof TableEllipsis) {
          child.on('action', _.partial(onRowAction, row));
        }
      });
      table.selection = 'single';
      table.striped = false;
      table.selectable = true;
      state.addPageDependencies([letters, decisions, doc]).on('page:loaded', function () {
        region.show(root);
      }).on('page:error', function () {
        app.navigate(RouteHelper.createLink('submission:detail', doc, {
          studyId: 'studyId',
          documentId: 'id'
        }).slice(1), {
          trigger: true
        });
        root.destroy();
      }).on('page:cancel', function () {
        root.destroy();
      });
      state.addPageDependencies([doc, decisions]);
      doc.fetch();
      decisions.fetch();
    }
  });
  module.exports = SubmissionLetterListController;
});

